function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Analytics"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector 1 (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.4891 6.12781C18.9708 6.39791 19.1423 7.00739 18.8722 7.48912L13.9244 16.3135C13.7926 16.5487 13.5713 16.7207 13.3109 16.7904C13.0505 16.8602 12.7729 16.8218 12.5412 16.684L7.9691 13.9661L4.87224 19.4891C4.60213 19.9709 3.99264 20.1424 3.51092 19.8723C3.02919 19.6022 2.85765 18.9927 3.12776 18.511L6.72624 12.0933C6.8581 11.8581 7.07933 11.6862 7.33975 11.6164C7.60018 11.5467 7.87774 11.585 8.10948 11.7228L12.6815 14.4408L17.1277 6.51099C17.3979 6.02926 18.0073 5.85771 18.4891 6.12781Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 2 (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.9115 4.51136C19.4152 4.43464 19.8961 4.74896 20.028 5.24114L21.4921 10.7052C21.635 11.2387 21.3184 11.787 20.785 11.93C20.2515 12.0729 19.7032 11.7563 19.5602 11.2229L18.3278 6.62332L12.8825 7.45266C12.3365 7.53582 11.8265 7.16062 11.7433 6.61463C11.6602 6.06864 12.0354 5.55862 12.5814 5.47546L18.9115 4.51136Z",
  fill: "none"
}));

var SvgAnalytics = function SvgAnalytics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnalytics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/analytics.2ed7f3f6.svg";
export { ForwardRef as ReactComponent };